var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bd-layout-template-wrapper"},[_c('bd-layout-' + 'commonSys',{tag:"component",attrs:{"collapse":_vm.collapse,"device":_vm.device,"fixed-header":_vm.theme.fixedHeader}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }